/* eslint-disable no-use-before-define */

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

function waitUntilReady(timeoutMs = 10000) {
  return new Promise(resolve => {
    if (window.grecaptcha) {
      resolve(true);
      return;
    }

    const interval = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve(true);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      // console.warn('reCAPTCHA no disponible, continuando sin verificación');
      resolve(false);
    }, timeoutMs);
  });
}

export async function getTokenV3({ action }) {
  const loaded = await waitUntilReady();

  // Si no he ha podido procesar el script de google
  if (!loaded) {
    return { token: null };
  }

  const token = await window.grecaptcha.execute(SITE_KEY, { action });
  return { token };
}
